<template>
    <div class="home_box">
		<div class="content_box">
			<div class="main_box">
				<img class="main_img" src="@/assets/home/logo2.jpg" alt="">
				<div class="main_right">
					<div v-for="item,index in tabList" :key="index">
						<router-link :to="item.to" class="main_center" :class="tabberType==index?'':'main_center2'">
							{{ item.name }}
						</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
    name: "HelloWorld",
    props: ['tabberType'],
	data() {
		return {
			tabList: [{
				name: '首页',
				to: {
					path: '/',
				}
			}, {
				name: '企业简介',
				to: {
					path: '/intro',
				}
			}, {
				name: '工程项目',
				to: {
					path: '/article',
				}
			}, {
				name: '企业资质',
				to: {
					path: '/resource',
				}
			}, {
				name: '动态信息',
				to: {
					path: '/message',
				}
			}, {
				name: '联系我们',
				to: {
					path: '/my',
				}
			}],
		};
	},
	mounted() {
		window.scrollTo({ top: 0, left: 0, behavior: "auto" });
	},
	methods: {

	}
};
</script>

<style scoped lang="less">
.home_box {
	width: 100%;
	height: 0.8rem;
}
.content_box{
	width: 100%;
	height: 0.8rem;
	background: #FFFFFF;
	display: flex;
	align-items: center;
	justify-content: center;
	position: fixed;
	left: 0;
	top: 0;
	z-index: 999;

	.main_box {
		width: 14.4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.main_img {
			width: 3.6rem;
			object-fit: contain;
			height: 0.68rem;
			flex-shrink: 0;
		}
		.main_right {
			display: flex;
			align-items: center;

			.main_center {
				height: 0.76rem;
				display: flex;
				align-items: center;
				justify-content: center;
				font-family: Source Han Sans CN;
				font-weight: 500;
				font-size: 0.2rem;
				color: #0059AA;
				border-bottom: 0.04rem solid #0059AA;
				cursor: pointer;
				margin-left: 0.6rem;
			}
			.main_center2 {
				border-bottom: 0.04rem solid #FFFFFF;
			}
		}
	}
}
</style>
